<template>
  <activity-layout>
    <template>
      <nav-menu :activeTab='activeTab'
                :menuTab='menuTab'
                @change='onMenuTabChange'
                class="nav-menu"></nav-menu>
      <router-view/>
      <comments class="comments"></comments>
    </template>

    <template slot='right-aside'>
      <right-aside :buttonName="$t('global.上传作品')"
                   :data='asideData'></right-aside>
    </template>
  </activity-layout>
</template>

<script>
import ActivityLayout from '@/layouts/ActivityLayout'
import NavMenu from '@/components/activity/NavMenu'
import Comments from '@/components/activity/Comments'
import RightAside from '@/components/activity/RightAside'

export default {
  name: 'Match',
  components: {
    ActivityLayout,
    NavMenu,
    Comments,
    RightAside
  },
  data() {
    return {
      activeTab: '0',
      menuTab: [this.$t('global.竞赛介绍'), this.$t('global.全部作品'), this.$t('global.参赛人员'), this.$t('global.我的作品'), this.$t('global.获奖作品'), this.$t('global.关于主办方')],
      asideData: {
        id: Number,
        thumb: '',
        title: '',
        isOfficial: Boolean,
        registrationTimeStart: Date,
        registrationTimeEnd: Date,
        holdingTimeStart: Date,
        holdingTimeEnd: Date
      }
    }
  },
  watch: {
    $route: function() {
      this.changeNavMenuWithRoute()
      let currentID = this.$route.params.id
      if (currentID == this.asideData.id) return
      this.getRightAsideData(currentID)
    }
  },
  methods: {
    changeNavMenuWithRoute() {
      switch (this.$route.name) {
        case 'matchIntroduction':
          this.activeTab = '0'
          break
        case 'matchAllWorks':
          this.activeTab = '1'
          break
        case 'matchParticipant':
          this.activeTab = '2'
          break
        case 'matchMyCreation':
          this.activeTab = '3'
          break
        case 'matchWinningWorks':
          this.activeTab = '4'
          break
        case 'matchAbout':
          this.activeTab = '5'
          break
        default:
          this.activeTab = '0'
      }
    },

    onMenuTabChange: function(index) {
      index = Number(index)
      switch (index) {
        case 0:
          this.$router.push('introduction')
          break
        case 1:
          this.$router.push('allWorks')
          break
        case 2:
          this.$router.push('participant')
          break
        case 3:
          this.$router.push('myCreation')
          break
        case 4:
          this.$router.push('winningWorks')
          break
        case 5:
          this.$router.push('about')
          break
      }
    },

    getRightAsideData(activityId) {
      this.$http
        .get('/api/activity/detail', {
          params: {
            activityId: activityId
          }
        })
        .then(data => {

          let d = data.data
          let asideData = {}
          asideData.id = d.id
          asideData.thumb = d.organizeAvatar
          asideData.title = d.organizeName || `MANA${this.$t('global.全球艺术网络科技')}`
          asideData.isOfficial = true
          asideData.info = d.organizeInfo
          // asideData.info = 'fdsafjdsf kjaskfjdklsaj fkdjsaioejfaio ojfieoanfjlvjai 布鲁克林的艺术家们对我们地区的电影和艺术 场景感兴趣 fjewio 布鲁克林的艺术家们对我们地区的电影和艺术 场景感兴趣。发布您的视频分享想法计划见面会 或合作开始拍摄...';
          asideData.registrationTimeStart = d.signStartTime
          asideData.registrationTimeEnd = d.signEndTime
          asideData.holdingTimeStart = d.holdStartTime
          asideData.holdingTimeEnd = d.holdEndTime
          this.asideData = asideData
        })
    },

    getCommentsData() {
      // TODO
    }
  },

  created() {
    this.changeNavMenuWithRoute()
    this.getRightAsideData(this.$route.params.id)
  }
}
</script>

<style lang="stylus" scoped>
.nav-menu
  height 1rem
  padding 0 0.9rem
  margin-bottom 0.2rem
.comments
  margin-bottom 0.8rem
</style>



// WEBPACK FOOTER //
// src/pages/activity/Match.vue